import { Nav, NavItem, NavLink } from "reactstrap";
import { BUSSINES_VERTICAL_DATA } from "../../../../Data/FormLayout";
import { H6 } from "../../../../AbstractElements";
import { BusinessFormCommonProps } from "../../../../Type/FormLayoutType";

const NavComponent = ({ callbackActive, activeTab }: BusinessFormCommonProps) => {
  const handleTab = (id: number | undefined) => {
    if (id !== undefined) callbackActive(id);
  };

  return (
    <Nav className="nav-pills horizontal-options">
      {BUSSINES_VERTICAL_DATA.map((data, index) => (
        <NavItem key={index}>
          <NavLink className={`${activeTab === index + 1 ? "active" : ""}`} onClick={() => handleTab(data.activeTab)}>
            <div className="horizontal-wizard">
              <div className="stroke-icon-wizard">
                <span>{index + 1}</span>
              </div>
              <div className="horizontal-wizard-content">
                <H6>{data.tittle}</H6>
              </div>
            </div>
          </NavLink>
        </NavItem>
      ))}
    </Nav>
  );
};

export default NavComponent;
